import { useAuth } from '../contexts/AuthContext';

/**
 * Dynamic watermark overlay for sensitive content.
 * Renders the user's name, email fragment, date/time, and a partial session ID
 * as a repeating semi-transparent pattern that is:
 * - Visible in screenshots
 * - Not selectable or copyable
 * - Rotated for maximum coverage
 */
export function Watermark({ opacity = 0.06, children }) {
  const { user } = useAuth();

  if (!user) return children || null;

  const name = user.name || user.email?.split('@')[0] || 'User';
  const emailHint = user.email ? user.email.slice(0, 4) + '***' : '';
  const now = new Date();
  const dateStr = now.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: '2-digit' });
  const timeStr = now.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
  const sessionId = (user.id || '').slice(0, 8);

  const line = `${name}  ${emailHint}  ${dateStr} ${timeStr}  ID:${sessionId}`;

  return (
    <div className="relative" data-testid="watermark-container">
      {children}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 overflow-hidden select-none z-[9999]"
        style={{ userSelect: 'none', WebkitUserSelect: 'none' }}
      >
        <div
          className="absolute w-[200%] h-[200%] -top-1/2 -left-1/2"
          style={{
            transform: 'rotate(-25deg)',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '60px 40px',
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          {Array.from({ length: 40 }, (_, i) => (
            <span
              key={i}
              className="whitespace-nowrap font-mono"
              style={{
                fontSize: '11px',
                color: `rgba(255,255,255,${opacity})`,
                letterSpacing: '0.05em',
                lineHeight: '1',
              }}
            >
              {line}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
